module.exports = __webpack_public_path__ + "img/config.e930b877.png";